if (!customElements.get('newsletter-embed')) {
    const countryFromServerTiming = (header) => {
        if (!header) return '';

        const match = header.match(/country;desc="([A-Za-z]{2})"/);

        return match ? match[1].toUpperCase() : '';
    };

    class NewsletterEmbed extends HTMLElement {
        connectedCallback() {
            this.#load();
        }

        async #load() {
            const iframe = this.querySelector('iframe');

            if (!iframe || iframe.getAttribute('src')) return;

            const country = await this.#detectCountry();
            const src = country === 'US' ? this.dataset.usSrc : this.dataset.internationalSrc;

            if (src) iframe.src = src;
        }

        async #detectCountry() {
            const root = window.Shopify?.routes?.root || '/';

            try {
                const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`);

                if (response.ok) {
                    const data = await response.json();
                    const handle = data?.detected_values?.country?.handle;

                    if (handle) return handle.toUpperCase();
                }

                const timedCountry = countryFromServerTiming(response.headers.get('server-timing'));

                if (timedCountry) return timedCountry;
            } catch (error) {
                console.error(error);
            }

            return (this.dataset.fallbackCountry || '').toUpperCase();
        }
    }

    customElements.define('newsletter-embed', NewsletterEmbed);
}
